<template>
  <div class="content Tabs">

    <b-tabs card>
      <b-tab v-if="currentUser.role != 'Reader'" :title="lang.tab_Tasks" :title-link-class="textColors" :title-item-class="textColors" active>

        <ProjectTasksComponent :lang="lang.Tasks" parent="details"></ProjectTasksComponent>

        
      </b-tab>
      <!-- <b-tab :title="lang.tab_Included" :title-link-class="textColors" :title-item-class="textColors">
      
        <WhatIsIncludedComponent :lang="lang.WhatIsIncluded" parent="details"></WhatIsIncludedComponent>
      </b-tab> -->
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_Report" :title-link-class="textColors" :title-item-class="textColors">
        
        <ProjectChangeReportComponent :lang="lang.ProjectReport" parent="details"></ProjectChangeReportComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_FileComparison" :title-link-class="textColors" :title-item-class="textColors">

        <FileComparisonComponent :lang="lang.FileComparison"></FileComparisonComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_Delegations" :title-link-class="textColors" :title-item-class="textColors">

        <DelegationsReportComponent :lang="lang.Delegations"></DelegationsReportComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_IPCImage" :title-link-class="textColors" :title-item-class="textColors">
      
        <IpcViewerComponent name="CompareVariants" :lang="lang.IPCViewer" :zooming="true"></IpcViewerComponent>
      
      </b-tab>


    </b-tabs>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import ProjectTasksComponent from '@/components/shared/ProjectTasksComponent'
import WhereUseTableComponent from '@/components/shared/WhereUseTableComponent'
import ProjectChangeReportComponent from '@/components/shared/ProjectChangeReportComponent'
import FileComparisonComponent from '@/components/shared/FileComparisonComponent'
import DelegationsReportComponent from '@/components/shared/DelegationsReportComponent'
import IpcViewerComponent from '@/components/shared/IpcViewerComponent'

// import CompareLibrariesComponent from '@/components/shared/CompareLibrariesComponent'
// import WhereLibUsedComponent from '@/components/shared/WhereLibUsedComponent'
//import WhatIsIncludedComponent from '@/components/shared/WhatIsIncludedComponent'


export default {
  name: "Content",
  components: {
    ProjectTasksComponent,
    WhereUseTableComponent,
    ProjectChangeReportComponent,
    FileComparisonComponent,
    DelegationsReportComponent,
    IpcViewerComponent
    
    // CompareLibrariesComponent,
    // WhereLibUsedComponent,
    //WhatIsIncludedComponent
   

  },
  props:{
    lang: Object
  },
  data () {
    return {

      
    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      appConf: 'appConf',
      currentUser: 'currentUser'
    }),
    isAlternativeSelected(){
      return this.$store.getters.selectedAlternative.distributorPartId != undefined;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    
  }
}
</script>

<style scooped>

</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectDetails/Right/Content/Content.vue